import { z } from 'zod';
import { IsoDateSchema, MoneySchema } from './common';

export const InvoiceStatusSchema = z.enum([
  'borrador',
  'emitida',
  'enviada',
  'cobrada',
  'vencida',
]);
export type InvoiceStatus = z.infer<typeof InvoiceStatusSchema>;

export const InvoiceLineInputSchema = z.object({
  position: z.number().int().min(0),
  description: z.string().min(1),
  quantity: z.number().min(0).default(1),
  unitPrice: z.number().min(0).default(0),
});
export type InvoiceLineInput = z.infer<typeof InvoiceLineInputSchema>;

export const CreateInvoiceIssuedSchema = z.object({
  clientId: z.string().uuid(),
  ownerId: z.string().uuid().optional(),
  concept: z.string().default(''),
  dueDate: IsoDateSchema.nullish(),
  irpfPct: z.number().min(0).max(100).optional(),
  ivaPct: z.number().min(0).max(100).optional(),
  notes: z.string().nullish(),
  // Admin-only; ignored when set by a non-admin actor.
  isPrivate: z.boolean().optional(),
  lines: z.array(InvoiceLineInputSchema).default([]),
});
export type CreateInvoiceIssuedRequest = z.infer<typeof CreateInvoiceIssuedSchema>;

export const UpdateInvoiceIssuedSchema = z.object({
  clientId: z.string().uuid().optional(),
  concept: z.string().optional(),
  dueDate: IsoDateSchema.nullish(),
  irpfPct: z.number().min(0).max(100).optional(),
  ivaPct: z.number().min(0).max(100).optional(),
  notes: z.string().nullish(),
  lines: z.array(InvoiceLineInputSchema).optional(),
  payDate: IsoDateSchema.nullish(),
  // Admin-only; ignored when set by a non-admin actor. Editable in any status.
  isPrivate: z.boolean().optional(),
});
export type UpdateInvoiceIssuedRequest = z.infer<typeof UpdateInvoiceIssuedSchema>;

export const SendInvoiceSchema = z.object({
  sendDate: IsoDateSchema.optional(),
});
export type SendInvoiceRequest = z.infer<typeof SendInvoiceSchema>;

export const PayInvoiceSchema = z.object({
  payDate: IsoDateSchema.optional(),
});
export type PayInvoiceRequest = z.infer<typeof PayInvoiceSchema>;

// Allowed status transitions used by both backend and UI.
export const ALLOWED_TRANSITIONS: Record<InvoiceStatus, InvoiceStatus[]> = {
  borrador: ['emitida'],
  emitida: ['enviada'],
  enviada: ['cobrada', 'vencida'],
  vencida: ['cobrada'],
  cobrada: [],
};

export type MoneyString = z.infer<typeof MoneySchema>;
